import { APP_VERSION } from "@/config/version";

export function BetaBadge({ className = "" }: { className?: string }) {
  return (
    <span
      aria-label={`${APP_VERSION}`}
      title={APP_VERSION}
      className={`inline-flex items-center rounded-full border border-amber-300 bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-800 ${className}`}
    >
      Beta
    </span>
  );
}